import { HiTrash, HiX } from "react-icons/hi";
import { useTranslation } from "@repo/core";

const NoteDeleteConfirmModal = ({
  isDeleting,
  handleNoteDeleteConfirm,
  handleNoteDeleteCancel,
}: {
  isDeleting: boolean;
  handleNoteDeleteConfirm: () => void;
  handleNoteDeleteCancel: () => void;
}) => {
  const { tStrategy, tCommon } = useTranslation();

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          handleNoteDeleteCancel();
        }
      }}
    >
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          {tStrategy("note.deleteConfirmTitle")}
        </h3>
        <p className="text-gray-600 mb-6">
          {tStrategy("note.deleteConfirmMessage")}
        </p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={handleNoteDeleteConfirm}
            disabled={isDeleting}
            className="cursor-pointer flex items-center gap-2 px-4 py-2 bg-red-600 text-white hover:bg-red-700 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <HiTrash size={16} />
            {isDeleting ? tStrategy("editModal.saving") : tCommon("delete")}
          </button>
          <button
            onClick={handleNoteDeleteCancel}
            disabled={isDeleting}
            className="cursor-pointer flex items-center gap-2 px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <HiX size={16} />
            {tCommon("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoteDeleteConfirmModal;
